const dummy_t = (translationKey) => translationKey;

export default [
  {
    externalPath: {
      'cs-CZ': 'https://dietaoxy.pl/cz',
      'pl-PL': 'https://dietaoxy.pl/',
    },
    translationKey: dummy_t('menu.blog'),
  },
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: {
      'cs-CZ': 'https://kontaktoxycz.zendesk.com/hc/cs-cz',
      'pl-PL': 'https://kontaktoxypl.zendesk.com/hc/pl',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
